import styled from 'styled-components';
import { StyledPopupWidgetCon, StyledProductItemCon } from '../../../../skins';

export const StyledSlideoutLinePopupWidgetCon = styled(StyledPopupWidgetCon)``;

export const StyledSlideoutLineProductItemCon = styled(StyledProductItemCon)`
  flex-direction: column;
  border-bottom: 1px solid #eeeeee;

  &.mr-product-item--primary-product {
    border-bottom: 0px solid transparent;
  }
`;
